import React from 'react';
import Icon from '../../../components/Icon';
import Theme from '../../../theme';

export const HomeIcon = ({
  color = Theme.GREY_MEDIUM,
  size = 30
}) => (
  <Icon
    size={size}
    color={color}
    name={'md-home'}
  />
);